export default "__VITE_ASSET__CLIZ9cgb__"